export * from './NavigationMenu';

export const expandedMenuWidth = 280;
export const collapsedMenuWidth = 56;